import $ from 'jquery';
import InputService from '../service/InputService';

$('.control-input').blur(function () {
    const id = $(this).parents('.control').attr('data-id');
    InputService.setValue(id, $(this).val());
});

$('.control-input').keyup(function (event) {
    if (event.keyCode == 13) {
        $('.control-input').blur();
    }
});

$('body').on('click', '.control-input__icon', function () {
    $(this).closest('.control-input').blur();
});
